import { render, staticRenderFns } from "./ButtonNonEditable.vue?vue&type=template&id=4c082329&scoped=true&lang=html&"
import script from "./ButtonNonEditable.vue?vue&type=script&lang=js&"
export * from "./ButtonNonEditable.vue?vue&type=script&lang=js&"
import style0 from "./ButtonNonEditable.vue?vue&type=style&index=0&id=4c082329&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c082329",
  null
  
)

export default component.exports